import ViewController from '../../core/viewController';

import LoadingTopBar from '../../view/component/loadingBar/loadingBar';
import ReparationView from '../../view/page/reparation/reparationView';

import BalanceModel from "../../model/balance";
import Session from '../../helper/session';

export default class ReparationViewController extends ViewController 
{
	constructor(props) {
		super(props);

		this.state =
		{
        }
	}

	toggleModal(action, activeModal)
	{
		this._isMounted && this.props.toggleModal(action, activeModal);
	}

	recharge(temp)
	{
		this._isMounted && this.startLoading()
		this._isMounted && BalanceModel
		?.recharge(temp)
		.then(async data =>
		{
			if(parseInt(data?.result) === 1)
			{
				this._isMounted && this.showErrMsg(this.i18n("msg_changesSaved"), "success");
				window.location='/overview';
			}
			else
			{
				this._isMounted && this.showErrMsg(data?.message, "error");
			}
		})
		.catch(e =>
		{
			this._isMounted && this.stopLoading();		
		});
	}

	goBack() 
	{
		this.props.history.goBack()
	}
    
	viewControllerDidMount()
	{
	}
	
	render() {
		if (Session.isLoggedIn()) 
        {
			return (
				<>
					<LoadingTopBar
						val={this.state?.loadingBarProgress}
					/>
					<ReparationView
					
					recharge={this.recharge.bind(this)}/>
				</>
			);
		}
        else 
        {
            window.location.href = "/login";
        }
    }
}